import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg, NodeSocketKindMap } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { ArgoConnectionKindEnum } from '@redviking/argonaut-util/types/db-enums/argo/connection_kind';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec, RequiredSockets } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const tcpConnectionNodeSpec: NodeSpec<NodeCfg<'tcpConnection'>> = {
    nodeCategory: 'connection',
    requiredSockets: (_node, availableInputs, availableOutputs) => {
        const required: ReturnType<RequiredSockets<'tcpConnection', NodeSocketKindMap['tcpConnection']>> = {
            required: [],
            // this conditionallyRequired statement basically says at least one socket must be wired up
            conditionallyRequired: [ {
                kind: 'or',
                availableOptions: [ ...availableInputs, ...availableOutputs ],
            } ],
        };
        return required;
    },
    kindLabel: 'TCP connection',
    controls: nodeCfg => ({
        connectionId: defineControlOpts({
            cfg: {
                kind: 'connectionSelect',
                label: 'Connection',
                allowedConnectionKinds: [ ArgoConnectionKindEnum.TcpClient, ArgoConnectionKindEnum.TcpServer ],
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.connectionId,
        }),
    }),
    cfg: () => ({
        id: getUID(),
        kind: 'tcpConnection',
        width: 220,
        controlValues: {
            connectionId: '',
        },
    }),
    inputs: cfg => ({
        sendMessage: { socket: 'event', label: 'Send Message' },
        messageToSend: {
            socket: 'string',
            label: 'Message',
            controlOpts: defineControlOpts({
                cfg: { kind: 'text' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                enableWithConnectedSocket: false,
                value: cfg.socketDefaults?.inputs?.messageToSend,
            }),
        },
    }),
    outputs: () => ({
        messageReceieved: { socket: 'event', label: 'Message Received' },
        receivedMessage: { socket: 'string', label: 'Message' },
    }),
    validator: node => node.controlValues.connectionId ? true : { connectionId: 'Connection id is required' },
};
